import { useContext, useEffect, useState } from "react";
import { petitions } from "../api/calls.js";
import { DataContext } from "../context/DataContext.jsx";
import feather from "feather-icons";
import { Outlet, NavLink } from "react-router-dom";
import { toast } from "sonner";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import userDefault from "../img/user.png";
import imgLinkedin from "../frontend/assets/img/nav-icons/ln.webp";
import logo from "../img/logo.jpeg";
import logoFacebook from "../img/logoFacebook.png";
import logoInstagram from "../img/logoInstagram.png"
import LogoWhatsApp from "../img/logoWhatsApp.png";
import logoTiktok from "../img/logoTiktok.png";
import Customize from "../components/componentsTools/Customize.jsx";

export default function LayoutDashboard() {
  const { session, empresa, user } = useContext(DataContext);
  const [nodoP, setNodoP] = useState([]);
  const [permisos, setPermisos] = useState([]);

  const navigate = useNavigate();

  //ICONS
  const icon = [
    { id: 1, value: "shopping-bag" },
    { id: 2, value: "shopping-cart" },
    { id: 3, value: "briefcase" },
    { id: 4, value: "package" },
    { id: 5, value: "users" },
    { id: 6, value: "pie-chart" },
    { id: 7, value: "archive" },
    { id: 8, value: "settings" },
  ];

  function getFecha() {
    const fecha = new Date();
    return format(fecha, "dd/MM/yyyy", { locale: es });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (Object.keys(empresa).length > 0 && Object.keys(user).length > 0) {
        const obj = session();
        const response = await petitions.getNodosP(empresa.idEmpresa, obj.token);
        if (response.status === "success") {
          setNodoP(response.data);
          const permisos = await petitions.getPermisos(
            user.idUsuario,
            empresa.idEmpresa,
            obj.token
          );
          if (permisos.status === "success") {
            setPermisos(permisos.data);
          } else {
            const msgPermiso =
              typeof permisos.code === "string"
                ? permisos.message
                : permisos.data;
            toast.error(msgPermiso);
          }
        } else {
          const msg =
            typeof response.code === "string" ? response.message : response.data;
          toast.error(msg);
        }
      }
    };

    fetchData();
  }, [empresa, user]);


  useEffect(() => {
    feather.replace();
  }, [nodoP]);

  //MÁS
  const selectEmpresa = () => {
    localStorage.removeItem("empresa");
    navigate("/SelectCompany", { replace: true });
    toast.info("Vuelva a seleccionar la empresa");
  };

  const closeSession = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, salir",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("empresa");
          localStorage.removeItem("session");
          navigate("/", { replace: true });
          toast.success("Sesión cerrada correctamente");
        }
      });
  };

  return (
    <>
    <main className="main" id="top">
      <nav className="navbar navbar-vertical navbar-expand-lg">
        <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
          <div className="navbar-vertical-content">
            <ul className="navbar-nav flex-column" id="navbarVerticalNav">
              <li className="nav-item">
                <p className="navbar-vertical-label">Menu principal</p>
                <hr className="navbar-vertical-line" />
                <div className="nav-item-wrapper">
                  <NavLink
                    className="nav-link label-1"
                    role="button"
                    data-bs-toggle=""
                    aria-expanded="false"
                    to="/main"
                  >
                    <div className="d-flex align-items-center">
                      <span className="nav-link-icon">
                        <span
                          data-feather="home"
                          style={{ width: "16px", height: "16px" }}
                        ></span>
                      </span>
                      <span className="nav-link-text">Home</span>
                    </div>
                  </NavLink>
                </div>
                {/* <div className="nav-item-wrapper">
                  <NavLink
                    className="nav-link label-1"
                    role="button"
                    data-bs-toggle=""
                    aria-expanded="false"
                    to="/main/signalgpt"
                  >
                    <div className="d-flex align-items-center">
                      <span className="nav-link-icon">
                        <span
                          data-feather="zap"
                          style={{ width: "16px", height: "16px" }}
                        ></span>
                      </span>
                      <span className="nav-link-text">Signal GPT</span>
                      <span className="badge ms-2 badge badge-phoenix badge-phoenix-info rounded-5">Pronto</span>
                    </div>
                  </NavLink>
                </div> */}
              </li>
              <li className="nav-item">
                <p className="navbar-vertical-label">Facturación electronica</p>
                <hr className="navbar-vertical-line" />
                {nodoP &&
                  nodoP.length > 0 &&
                  nodoP.map((n) => (
                    <div className="nav-item-wrapper" key={n.id}>
                      <a
                        className="nav-link dropdown-indicator label-1"
                        href={"#" + n.id}
                        role="button"
                        data-bs-toggle="collapse"
                        aria-expanded="false"
                        aria-controls={n.id}
                      >
                        <div className="d-flex align-items-center">
                          <div className="dropdown-indicator-icon">
                            <span className="fas fa-caret-right"></span>
                          </div>
                          <span className="nav-link-icon">
                            <span
                              data-feather={
                                icon.find((icon) => icon.id === n.id)?.value
                              }
                              style={{ width: "16px", height: "16px" }}
                            ></span>
                          </span>
                          <span className="nav-link-text">{n.name}</span>
                        </div>
                      </a>
                      <div className="parent-wrapper label-1">
                        <ul
                          className="nav collapse parent"
                          data-bs-parent="#navbarVerticalCollapse"
                          id={n.id}
                        >
                          <li className="collapsed-nav-item-title d-none">
                            {n.name}
                          </li>
                          {permisos &&
                            permisos.length > 0 &&
                            permisos.map(
                              (p) =>
                                n.id === p.idNodoP &&
                                p.data.map((e) =>
                                  e.idNodoS > 0 ? (
                                    <li
                                      key={e.nombreNodoS.replace(/\s+/g, "")}
                                      className="nav-item"
                                    >
                                      <a
                                        className="nav-link dropdown-indicator"
                                        href={
                                          "#" +
                                          e.nombreNodoS.replace(/\s+/g, "")
                                        }
                                        data-bs-toggle="collapse"
                                        aria-expanded="false"
                                        aria-controls={e.nombreNodoS.replace(
                                          /\s+/g,
                                          ""
                                        )}
                                      >
                                        <div className="d-flex align-items-center">
                                          <div className="dropdown-indicator-icon">
                                            <span className="fas fa-caret-right"></span>
                                          </div>
                                          <span className="nav-link-text">
                                            {e.nombreNodoS}
                                          </span>
                                        </div>
                                      </a>

                                      <div className="parent-wrapper">
                                        <ul
                                          className="nav collapse parent"
                                          data-bs-parent="#e-commerce"
                                          id={e.nombreNodoS.replace(/\s+/g, "")}
                                        >
                                          {e.nodos.map((c) => (
                                            <li
                                              className="nav-item"
                                              key={c.idNodo}
                                            >
                                              <NavLink
                                                className="nav-link"
                                                data-bs-toggle=""
                                                aria-expanded="false"
                                                to={"/main/" + c.page}
                                              >
                                                <div className="d-flex align-items-center">
                                                  <span className="nav-link-text">
                                                    {c.nombreNodo}
                                                  </span>
                                                </div>
                                              </NavLink>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </li>
                                  ) : (
                                    e.nodos.map((nodo) => (
                                      <li
                                        key={nodo.nombreNodo.replace(
                                          /\s+/g,
                                          ""
                                        )}
                                        className="nav-item"
                                      >
                                        <NavLink
                                          className="nav-link"
                                          to={"/main/" + nodo.page}
                                          data-bs-toggle=""
                                          aria-expanded="false"
                                        >
                                          <div className="d-flex align-items-center">
                                            <span className="nav-link-text">
                                              {nodo.nombreNodo}
                                            </span>
                                          </div>
                                        </NavLink>
                                      </li>
                                    ))
                                  )
                                )
                            )}
                        </ul>
                      </div>
                    </div>
                  ))}
              </li>
              <li className="nav-item">
                <p className="navbar-vertical-label">Más</p>
                <hr className="navbar-vertical-line" />
                <div className="nav-item-wrapper">
                  <a
                    className="nav-link label-1"
                    role="button"
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      selectEmpresa();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <span className="nav-link-icon">
                        <span
                          data-feather="database"
                          style={{ width: "16px", height: "16px" }}
                        ></span>
                      </span>
                      <span className="nav-link-text">Seleccionar empresa</span>
                    </div>
                  </a>
                </div>
                <div className="nav-item-wrapper">
                  <a
                    className="nav-link label-1"
                    role="button"
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      closeSession();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <span className="nav-link-icon">
                        <span
                          data-feather="log-out"
                          style={{ width: "16px", height: "16px" }}
                        ></span>
                      </span>
                      <span className="nav-link-text">Cerrar sesión</span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="navbar-vertical-footer">
          <button className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center">
            <span className="uil uil-left-arrow-to-left fs-8"></span>
            <span className="uil uil-arrow-from-right fs-8"></span>
            <span className="navbar-vertical-footer-text ms-2">Minimizar</span>
          </button>
        </div>
      </nav>
      {/*NAV BAR HORIZONTAL SUPERIOR*/}
      <nav
        className="navbar navbar-top fixed-top navbar-expand"
        id="navbarDefault"
      >
        <div className="collapse navbar-collapse justify-content-between">
          <div className="navbar-logo">
            <button
              className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarVerticalCollapse"
              aria-controls="navbarVerticalCollapse"
              aria-expanded="false"
              aria-label="Toggle Navigation"
            >
              <span className="navbar-toggle-icon">
                <span className="toggle-line"></span>
              </span>
            </button>
            <a className="navbar-brand me-1 me-sm-3" href="#">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img
                    src={
                      empresa.logo
                        ? `data:image/png;base64,${empresa.logo}`
                        : logo
                    }
                    alt={empresa.rSocial || "Logo"}
                    width="40"
                    className="rounded-circle"
                  />
                  <p className="logo-text ms-2 d-none d-sm-block" style={{ fontSize: "1.3rem" }}>
                    {empresa.rSocial}
                  </p>
                </div>
              </div>
            </a>
          </div>
          <div className="navbar-nav">
            <div
              // className="card border-1 text-center px-4 py-2 rounded-4"
            >
              <span className="">{empresa.nombreComercial}</span>
            </div>
          </div>
          <div className="navbar-nav">
            <div
              // className="card border-1 text-center px-4 py-2 rounded-4"
            >
              <span>{getFecha()}</span>
            </div>
          </div>
          <ul className="navbar-nav navbar-nav-icons flex-row">
            <li className="nav-item">
              <div className="theme-control-toggle fa-icon-wait px-2">
                <input
                  className="form-check-input ms-0 theme-control-toggle-input"
                  type="checkbox"
                  data-theme-control="phoenixTheme"
                  value="dark"
                  id="themeControlToggle"
                />
                <label
                  className="mb-0 theme-control-toggle-label theme-control-toggle-light"
                  htmlFor="themeControlToggle"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  title="Tema"
                >
                  <span
                    className="icon"
                    data-feather="moon"
                    style={{ width: "16px", height: "16px"}}
                  ></span>
                </label>
                <label
                  className="mb-0 theme-control-toggle-label theme-control-toggle-dark"
                  htmlFor="themeControlToggle"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  title="Tema"
                  style={{ backgroundColor:"#e6edff", color:"#3874ff"}}
                >
                  <span
                    className="icon"
                    data-feather="sun"
                    style={{ width: "16px", height: "16px"}}
                  ></span>
                </label>
              </div>
            </li>
            <li className="nav-item dropdown">
              <button
                className="nav-link"
                href="#"
                style={{ width: "min-width: 2.25rem" }}
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="outside"
                disabled ={true}
              >
                <span
                  data-feather="bell"
                  style={{ height: "20px", width: "20px" }}
                ></span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
                id="navbarDropdownNotfication"
                aria-labelledby="navbarDropdownNotfication"
              >
                <div className="card position-relative border-0">
                  <div className="card-header p-2">
                    <div className="d-flex justify-content-between">
                      <h5 className="text-body-emphasis mb-0">Notificatons</h5>
                      <button
                        className="btn btn-link p-0 fs-9 fw-normal"
                        type="button"
                      >
                        Mark all as read
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div
                      className="scrollbar-overlay"
                      style={{ height: "27rem" }}
                    >
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative read border-bottom">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <img
                                className="rounded-circle"
                                src="assets/img/team/40x40/30.webp"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Jessie Samson
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">💬</span>Mentioned
                                you in a comment.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10">
                                  10m
                                </span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">10:41 AM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative unread border-bottom">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <div className="avatar-name rounded-circle">
                                <span>J</span>
                              </div>
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Jane Foster
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">📅</span>Created an
                                event.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10">
                                  20m
                                </span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">10:20 AM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#!">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative unread border-bottom">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <img
                                className="rounded-circle avatar-placeholder"
                                src="assets/img/team/40x40/avatar.webp"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Jessie Samson
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">👍</span>Liked your
                                comment.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10">
                                  1h
                                </span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">9:30 AM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#!">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative unread border-bottom">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <img
                                className="rounded-circle"
                                src="assets/img/team/40x40/57.webp"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Kiera Anderson
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">💬</span>Mentioned
                                you in a comment.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10"></span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">9:11 AM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#!">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative unread border-bottom">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <img
                                className="rounded-circle"
                                src="assets/img/team/40x40/59.webp"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Herman Carter
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">👤</span>Tagged you
                                in a comment.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10"></span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">10:58 PM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#!">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2 px-sm-3 py-3 notification-card position-relative read ">
                        <div className="d-flex align-items-center justify-content-between position-relative">
                          <div className="d-flex">
                            <div className="avatar avatar-m status-online me-3">
                              <img
                                className="rounded-circle"
                                src="assets/img/team/40x40/58.webp"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 me-sm-3">
                              <h4 className="fs-9 text-body-emphasis">
                                Benjamin Button
                              </h4>
                              <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                <span className="me-1 fs-10">👍</span>Liked your
                                comment.
                                <span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10"></span>
                              </p>
                              <p className="text-body-secondary fs-9 mb-0">
                                <span className="me-1 fas fa-clock"></span>
                                <span className="fw-bold">10:18 AM </span>August
                                7,2021
                              </p>
                            </div>
                          </div>
                          <div className="d-none d-sm-block">
                            <button
                              className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-boundary="window"
                              aria-haspopup="true"
                              aria-expanded="false"
                              data-bs-reference="parent"
                            >
                              <span className="fas fa-ellipsis-h fs-10 text-body"></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end py-2">
                              <a className="dropdown-item" href="#!">
                                Mark as unread
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer p-0 border-top border-translucent border-0">
                    <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
                      <a className="fw-bolder" href="pages/notifications.html">
                        Notification history
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link"
                id="navbarDropdownNindeDots"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
                  <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
                  <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
                  <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
                </svg>
              </a>
              <div
                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-nine-dots shadow border"
                aria-labelledby="navbarDropdownNindeDots"
              >
                <div className="card bg-body-emphasis position-relative border-0">
                  <div
                    className="card-body pt-3 px-3 pb-0 overflow-auto scrollbar"
                    style={{ height: "12rem" }}
                  >
                    <div className="row text-center align-items-center gx-0 gy-0">
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          target="_blank"
                          rel="noopener"
                          href="https://www.linkedin.com/company/signalr/"
                        >
                          <img
                            src={imgLinkedin}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Linkedin
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="https://www.facebook.com/share/162xxuEPHB/?mibextid=wwXIfr"
                          target="_blank"
                          rel="noopener"
                        >
                          <img
                            src={logoFacebook}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Facebook
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="https://www.instagram.com/signalr.pe?igsh=OGJ3Z2Z0cXk0bmRr&utm_source=qr"
                          target="_blank"
                          rel="noopener"
                        >
                          <img
                            src={logoInstagram}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Instagram
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="https://wa.me/51945639655?text=Hola%2C%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20su%20software%20de%20facturaci%C3%B3n%20electr%C3%B3nica."
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={LogoWhatsApp}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            WhatsApp
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="https://www.tiktok.com/@signalr.pe?_t=ZS-8yz7egH8G2y&_r=1"
                          target="_blank"
                          rel="noopener"
                        >
                          <img
                            src={logoTiktok}
                            alt=""
                            width="30"
                            className="rounded-3"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            TikTok
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="https://signalare.com/"
                          target="_blank"
                          rel="noopener"
                        >
                          <img
                            src={logo}//"assets/img/nav-icons/behance.webp"
                            alt=""
                            width="30"
                            className="rounded-5"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Landing
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link lh-1 pe-0"
                id="navbarDropdownUser"
                href="#!"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div className="avatar avatar-l ">
                  <img className="rounded-circle " src={userDefault} alt="" />
                </div>
              </a>
              <div
                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                aria-labelledby="navbarDropdownUser"
              >
                <div className="card position-relative border-0">
                  <div className="card-body p-0">
                    <div className="text-center pt-4 pb-3">
                      <div className="avatar avatar-xl ">
                        <img
                          className="rounded-circle "
                          src={userDefault}
                          alt=""
                        />
                      </div>
                      <h6 className="mt-2 text-body-emphasis">
                        {user.nombres + " " + user.apellidos}
                      </h6>
                    </div>
                  </div>
                  <div
                    className="overflow-auto scrollbar"
                    style={{ height: "10rem" }}
                  >
                    <ul className="nav d-flex flex-column mb-2 pb-1">
                      <li className="nav-item">
                        <NavLink
                          className="nav-link px-3"
                          to="/main/SettingsUsuario"
                        >
                          <span
                            className="me-2 text-body"
                            data-feather="user"
                          ></span>
                          <span>Perfil</span>
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          className="nav-link px-3"
                          to="/main"
                        >
                          <span
                            className="me-2 text-body"
                            data-feather="pie-chart"
                          ></span>
                          Dashboard
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link px-3" href="#!" onClick={()=>{
                          toast.warning("Funcionalidad aun no disponible")
                        }}>
                          {" "}
                          <span
                            className="me-2 text-body"
                            data-feather="lock"
                          ></span>
                          Actividad
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link px-3" href="#!" onClick={()=>{
                          toast.warning("Funcionalidad aun no disponible")
                        }}>
                          {" "}
                          <span
                            className="me-2 text-body"
                            data-feather="settings"
                          ></span>
                          Configuración &amp; Privacidad{" "}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link px-3" href="#!" onClick={()=>{
                          toast.warning("Funcionalidad aun no disponible")
                        }}>
                          {" "}
                          <span
                            className="me-2 text-body"
                            data-feather="help-circle"
                          ></span>
                          Centro de ayuda
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="card-footer p-0 border-top border-translucent mb-3">
                    <br />
                    <div className="px-3">
                      {" "}
                      <button
                        className="btn btn-phoenix-secondary d-flex flex-center w-100 rounded-4 border-0 shadow-sm"
                        type="button"
                        onClick={()=>closeSession()}
                      >
                        {" "}
                        <span className="me-2" data-feather="log-out">
                          {" "}
                        </span>
                        Desconectar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div className="content">
        <Outlet />
      </div>
    </main>
    <Customize />    
    </>
  );
}